import React, { useContext, ReactNode } from 'react';
import { QuizById, QuizByIdVariables } from 'graphql/queries/types/QuizById';
import { Quiz, QuizStyles } from 'types';
import { getQuizById } from 'graphql/queries';
import { useQuery } from '@apollo/client';
import { Navigate } from 'react-router-dom';



interface QuizContextType {
    quiz: Quiz;
    refetch: () => void;
}

const QuizContext = React.createContext<QuizContextType | null | undefined>(null);

export function useQuizContext() {
    return useContext(QuizContext)!;
}

export function QuizProvider({ quizId, children }: { quizId: number; children?: ReactNode | undefined }) {
    const {
        loading,
        data,
        refetch
    } = useQuery<QuizById, QuizByIdVariables>(getQuizById, {
        variables: { quizId }
    });

    if (loading) {
        return null;
    }

    if(!loading && !data?.quiz_master_quizzes_by_pk) {
        return <Navigate to="/" replace />;
    }


    let quizStyles: QuizStyles | undefined = undefined;
    const dbQuiz = data?.quiz_master_quizzes_by_pk!;
    if (dbQuiz.quiz_style) {
        quizStyles = {
            fontStyles: dbQuiz.quiz_style.font_styles ?? undefined,
            backgroundStyles: dbQuiz.quiz_style.background_styles ?? undefined,
            titlePageStyles: dbQuiz.quiz_style.quiz_title_page_styles ?? undefined,
        }
    }
    const contextValue: QuizContextType | null = dbQuiz
    ? {
        quiz: {
            id: dbQuiz.id,
            name: dbQuiz.name,
            description: dbQuiz.description,
            publiclyAvailable: dbQuiz.publicly_available,
            authorUserId: dbQuiz.author_user_id!,
            quizTypeId: dbQuiz.quiz_type_id,
            genreId: dbQuiz.genre_id,
            createdAt: dbQuiz.created_at,
            eventId: dbQuiz.event_id,
            styles: quizStyles
        },
        refetch
    }
    : null;

    return <QuizContext.Provider value={contextValue}>{!loading && children}</QuizContext.Provider>;
}
